import { hotColumns } from "@/mocks/baoliao";

const tagColor: Record<string, string> = {
  leak: "bg-primary-100 text-primary-800",
  rumor: "bg-accent-100 text-accent-800",
  secret: "bg-secondary-100 text-secondary-900",
  debut: "bg-background-200 text-foreground-700",
};

export default function Columns() {
  return (
    <section id="columns" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-7">
          <div>
            <p className="text-xs text-primary-600 font-medium tracking-widest uppercase">COLUMNS</p>
            <h2 className="mt-1 text-2xl md:text-3xl text-foreground-950">四大常设栏目</h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">按内容类型归类，追你关心的那一路消息，不遗漏。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotColumns.map((col) => (
            <article
              key={col.id}
              className="group overflow-hidden rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-300 transition-colors"
            >
              <a href="#feed" className="block">
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={col.img}
                    alt={col.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span
                    className={`absolute top-3 left-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${tagColor[col.tagType]}`}
                  >
                    <i className="ri-price-tag-3-line" />
                    {col.title}
                  </span>
                </div>
                <div className="p-5">
                  <p className="text-sm leading-relaxed text-foreground-700 min-h-[60px]">{col.desc}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xs text-foreground-500">收录 {col.count} 条线索</span>
                    <span className="inline-flex items-center gap-1 text-sm text-primary-600 group-hover:translate-x-0.5 transition-transform">
                      去看看
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}